export const SYNC_WITH_BM_NOTIFICATION_RECEIVED = 'csv_export/SYNC_WITH_BM_NOTIFICATION_RECEIVED'
